import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// This component redirects to the main auth callback with state=connect
// The main AuthCallback component handles both login and connect flows
const GitHubConnectCallback = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  
  // Redirect to main callback with state parameter
  if (code) {
    return <Navigate to={`/auth/callback?code=${code}&state=connect`} replace />;
  }
  
  return <Navigate to="/organization" replace />;
};

export default GitHubConnectCallback;

